var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { WidgetElement } from '@blocksuite/lit';
import { nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { createCustomModal } from './custom-modal.js';
export const AFFINE_MODAL_WIDGET = 'affine-modal-widget';
let AffineModalWidget = class AffineModalWidget extends WidgetElement {
    open(options) {
        return createCustomModal(options, this.ownerDocument.body);
    }
    render() {
        return nothing;
    }
};
AffineModalWidget = __decorate([
    customElement(AFFINE_MODAL_WIDGET)
], AffineModalWidget);
export { AffineModalWidget };
//# sourceMappingURL=modal.js.map